<template>
<div class="chapter">
<div class="inner_page">
<div class="introduction" id="introduction-1">
<p class="centerImage"><img alt="images" id="img8" src="images/img8.jpg" style="max-width:100%;"/></p>
<p class="caption"><em class="italic">An early nineteenth century engraving of an execution outside Newgate Gaol.</em> <span class="fontS">Author’s collection</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 06b_Fouldeeds_introduction1.vue?2adf04a9